<script setup lang="ts">
const { imageHtml, combo = 'dark-green' } = defineProps<{
  imageHtml: string
  combo?: string
}>()

const image = computed(() => {
  // Should not happen since the component is client-only, but just in case, we return an empty image object to avoid errors during SSR.
  if (!import.meta.client) {
    return { src: '', alt: '', caption: '' }
  }

  const doc = new DOMParser().parseFromString(imageHtml, 'text/html')

  const img = doc.querySelector('img')
  if (!img)
    return { src: '', alt: '', caption: '' }

  const caption = doc.querySelector('figcaption')?.innerHTML || ''

  return {
    src: img.getAttribute('src') || '',
    alt: img.getAttribute('alt') || '',
    caption,
  }
})
</script>

<template>
  <figure
    v-if="image.src"
    class="relative my-4 md:mt-8 md:mb-16"
  >
    <img
      v-if="image.src"
      :src="image.src"
      :alt="image.alt"
    />
    <figcaption
      v-if="image.caption"
      :class="combo"
      class="-translate-y-3 bg-(--background,var(--event-background)) p-6 text-base text-(--foreground) md:absolute md:-bottom-8 md:-left-16 md:max-w-[46%] md:translate-y-0"
      v-html="image.caption"
    />
  </figure>
</template>
